<div class="jp-list">
  <div class="jp" *ngFor="let p of products.slice(0, 4)" (click)="open(p)">
    <div class="jp-img">
      <img *ngIf="p.images?.length" [src]="p.images[0]" [alt]="p.brand" />
      <i *ngIf="!p.images?.length" class="pi pi-box"></i>
    </div>
    <div class="jp-info">
      <div class="jp-brand">{{ p.brand }}</div>
      <div class="jp-name">{{ p.techDescription }}</div>
      <div class="jp-meta">
        <span class="jp-price">{{ fmt(p.minAllyPrice) }}</span>
        <span class="jp-stock" [ngClass]="p.stock">{{
          (p.stock === 'ok' ? 'repuestos.productCard.inStock' : p.stock === 'low' ? 'repuestos.productCard.lowStock' : 'repuestos.productCard.outOfStock') | transloco
        }}</span>
      </div>
    </div>
  </div>
</div>
